export default "__VITE_ASSET__DoJCecJ1__"